<template>
  <div class="mb-container" v-if="countdown !== 0">
    <div :class="{
      'mb-countdown': true,
      'bg3': hoursText.length > 2
    }">
      <span class="mb-hoursText">{{ hoursText }}</span>
      <span class="mb-minsText">{{ minsText }}</span>
      <span class="mb-ssText">{{ ssText }}</span>
    </div>
  </div>
</template>

<script>
import { get } from '@/utils/ajax'

export default {
  name: 'Countdown',
  props: {
    remoteTime: Number
  },
  data() {
    return {
      countdown: 0,
      originTime: 0,
      hoursText: '00',
      minsText: '00',
      ssText: '00'
    }
  },
  computed: {
    isShowCountDown() {
      return this.countdown < this.remoteTime
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init() {
      const time = await get('/home/common/times')
      this.countdown = time
      this.originTime = time

      const time1 = +Date.now()
      this.timer = setInterval(() => {
        const time2 = +Date.now()
        const accuracy = time2 - time1
        this.countdown = this.originTime + accuracy
        this.countDownAction()
        this.$emit('listen', this.isShowCountDown)
      }, 1000)
    },
    // 计算属性，返回剩余时间
    countDownAction() {
      const start = this.countdown
      const end = this.remoteTime
      const timestamp = (end - start) / 1000
      // let d = parseInt(timestamp / (24 * 60 * 60))
      const hours = Math.floor(timestamp / 3600)
      const mins = Math.floor(timestamp / 60 % 60)
      const ss = Math.floor(timestamp % 60)
      // console.log(hours, mins, ss)
      if (!this.isShowCountDown) {
        clearInterval(this.timer)
        this.timer = null
      } else {
        this.hoursText = this.prefixInteger(hours)
        this.minsText = this.prefixInteger(mins)
        this.ssText = this.prefixInteger(ss)
      }
    },
    prefixInteger(num) {
      return num < 10 ? `0${num}` : num + ''
    }
  },
  destroyed () {
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>

<style scoped lang="scss">
.mb-container {
  display: flex;
  justify-content: center;
  .mb-countdown {
    height: 132px;
    width: 458px;
    background: url('~@/assets/images/exam/countDown.png') no-repeat;
    background-size: contain;
    &.bg3 {
      width: 479px;
      background: url('~@/assets/images/exam/countDown3.png') no-repeat;
      background-size: contain;
      .mb-minsText {
        margin-right: 64px;
      }
    }
    // padding: 0 44px 0 37px;
    span {
      margin-top: 12px;
      display: inline-block;
      min-width: 80px;
      height: 80px;
      color: #fff;
      font-size: 66px;
      font-weight: Semibold;
      line-height: 80px;
      &.mb-hoursText {
        margin-left: 37px;
        position: relative;
        &::after {
          content: '小时';
          position: absolute;
          font-size: 24px;
          bottom: -80px;
          color: #4271FD;
          width: 100%;
          display: flex;
          justify-content: center;
          left: 50%;
          transform: translateX(-50%);
        }
      }
      &.mb-minsText {
        margin: 0 72px;
        position: relative;
        &::after {
          content: '分';
          position: absolute;
          font-size: 24px;
          bottom: -80px;
          color: #4271FD;
          width: 100%;
          display: flex;
          justify-content: center;
          left: 50%;
          transform: translateX(-50%);
        }
      }
      &.mb-ssText {
        position: relative;
        &::after {
          content: '秒';
          position: absolute;
          font-size: 24px;
          bottom: -80px;
          color: #4271FD;
          width: 100%;
          display: flex;
          justify-content: center;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }
}
</style>
